// src/seo/BookSEO.js
import { SEO_CONFIG } from './SEOConfig';
import { IMG_BASE_URL } from '../Helpers';

export const getBookSEO = (book) => {
    if (!book) return {};

    // Helper: Clean description
    const stripHtml = (html) => {
        if (!html) return "";
        return html.replace(/<[^>]*>?/gm, '');
    };

    const cleanDesc = stripHtml(book.description).substring(0, 160) + "...";
    const bookImage = IMG_BASE_URL + "books/" + book.image;

    // Get comma-separated author names
    const authorNames = book.authors?.map(a => a.author_name).join(", ") || "Uyirmozhy Author";

    return {
        title: `${book.book_name} by ${authorNames}`,
        description: cleanDesc,
        keywords: `${book.book_name}, Malayalam books, ${authorNames}, buy malayalam books, Uyirmozhy`,
        image: bookImage,

        // Schema for "Book" (Google treats this like a Product for shopping)
        schema: {
            "@context": "https://schema.org",
            "@type": "Book",
            "name": book.book_name,
            "author": book.authors?.map(author => ({
                "@type": "Person",
                "name": author.author_name
            })),
            "description": stripHtml(book.description),
            "image": bookImage,
            "publisher": {
                "@type": "Organization",
                "name": SEO_CONFIG.orgName
            },
            "inLanguage": "Malayalam",
            "offers": {
                "@type": "Offer",
                "price": book.mrp,
                "priceCurrency": "INR",
                "availability": "https://schema.org/InStock",
                "url": typeof window !== 'undefined' ? window.location.href : SEO_CONFIG.baseUrl
            }
        }
    };
};